import 'currencies_widget/scripts/currency_flags'
import CurrenciesDropdown from 'currencies_widget/scripts/currencies_dropdown'

$(function () {
  CurrenciesDropdown.init()
})
